import * as React from 'react';

import { translate } from '~l10n/client';

import { Divider } from '~shared/components/Divider';
import {
  IconDownload,
  IconEnvelope,
  IconGoogleDrive,
} from '~shared/components/icons/standard';

import { ReportOptionButton } from './ReportOptionButton';
import { ReportOptionControlList } from './ReportOptionControlList';
import {
  ExportReportDispatch,
  ReportOptionState,
} from './ReportOptionHookReducer';
import { ReportOptionType } from './ReportOptionTypes';

export const ReportOption = ({
  shouldShowProBadge,
  header,
  reportOptions,
  optionState,
  dispatch,
  isSaveToDriveDisabled = false,
  onPrepareDownload,
  onSendEmailToMe,
  onUploadToDrive,
  isFetching,
}: {
  shouldShowProBadge: boolean;
  optionState: ReportOptionState;
  header: React.ReactNode;
  reportOptions: ReportOptionType[];
  isSaveToDriveDisabled: boolean;
  onPrepareDownload: () => void;
  onSendEmailToMe: () => void;
  onUploadToDrive: () => void;
  dispatch: ExportReportDispatch;
  isFetching: boolean;
}) => {
  return (
    <section className="grid h-full p-8 report-options">
      {header}
      <div className="pt-8">
        <Divider />
        <ReportOptionControlList
          shouldShowProBadge={shouldShowProBadge}
          options={reportOptions}
          dispatch={dispatch}
          optionState={optionState}
        />
        <Divider />
      </div>
      <div className="pt-4">
        <div className="flex justify-center flex-wrap -ml-4 report-options__actions">
          <ReportOptionButton
            icon={<IconDownload />}
            onClick={onPrepareDownload}
            isDisabled={isFetching}
          >
            {translate('Download')}
          </ReportOptionButton>
          <div className="flex flex-auto justify-center flex-wrap">
            <ReportOptionButton
              icon={<IconEnvelope />}
              onClick={onSendEmailToMe}
              isDisabled={isFetching}
            >
              {translate('Email Me')}
            </ReportOptionButton>
            <ReportOptionButton
              icon={<IconGoogleDrive />}
              onClick={onUploadToDrive}
              isDisabled={isFetching || isSaveToDriveDisabled}
            >
              {translate('Save to Drive')}
            </ReportOptionButton>
          </div>
        </div>
      </div>
    </section>
  );
};
